'use strict';
var glideFunction = {
    pdp: {
        type: 'slider',
        perView: 1,
        gap: 10,
        peek: {
            before: 200,
            after: 0
        },
        breakpoints: {
            767: {
                gap: 0,
                peek: {
                    before: 0,
                    after: 0
                }
            }
        }
    },

    bellPdp: {
        type: 'slider',
        perView: 1,
        gap: 10,
        rewind: false,
        peek: {
            before: 200,
            after: 0
        },
        breakpoints: {
            767: {
                gap: 0,
                peek: {
                    before: 0,
                    after: 0
                }
            }
        }
    },

    plpQuickview: {
        type: 'slider',
        rewind: false,
        perView: 1,
        gap: 0
    },

    recommendation: {
        type: 'slider',
        rewind: false,
        perView: 4,
        bound: true,
        gap: 20,
        breakpoints: {
            767: {
                perView: 2
            }
        }
    },

    scrollThumb: {
        perView: 5,
        type: 'slider',
        rewind: false,
        bound: true,
        focusAt: 0,
        breakpoints: {
            767: {
                perView: 3.5,
                gap: 0
            }
        }
    },

    quickViewScrollThumb: {
        perView: 5,
        type: 'slider',
        rewind: false,
        bound: true,
        focusAt: 0,
        breakpoints: {
            767: {
                perView: 4,
                gap: 0
            }
        }
    },

    tech: {
        type: 'carousel',
        perView: 3,
        breakpoints: {
            767: {
                perView: 1
            },
            991: {
                perView: 2
            }
        }
    },

    video: {
        type: 'slider',
        perView: 1,
        rewind: false,
        bound: true,
        breakpoints: {
            767: {
                perView: 1
            }
        }
    },

    productRecommendationTile: {
        type: 'slider',
        rewind: false,
        perView: 2,
        gap: 0,
        bound: true,
        breakpoints: {
            991: {
                perView: 2
            }
        }
    }
};

module.exports = glideFunction;
